import { Layout, Menu } from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';
import React from 'react';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import MyUtil from '../../functions/MyUtil';
import PartRouters from '../../routes/routerPartners';
import routes, { RouteConfig } from '../../routes/routers';
import { User } from '../../type/entity';

function Sidebar() {
  const userInfo = reactLocalStorage.getObject('user.info') as User;

  const isPartner = userInfo?.user_role_id === 3;
  const routers = isPartner ? PartRouters : routes;

  function renderMenuItem(route: RouteConfig) {
    if (route.children) {
      return (
        <SubMenu key={route.name} title={route.name}>
          {route.children.map(renderMenuItem)}
        </SubMenu>
      );
    }

    if (
      MyUtil.hasPermission(route.path, 'view') ||
      isPartner ||
      Number(userInfo?.user_role_id) === 2
    ) {
      return (
        <Menu.Item key={route.path}>
          <Link to={route.path!}>{route.name}</Link>
        </Menu.Item>
      );
    }

    return null;
  }

  return (
    <Layout.Sider className="sidebar">
      <div className="logo">
        <img src="/logo-white.svg" alt="logo" className="w-100 p-3" />
      </div>
      <Menu theme="dark" mode="inline">
        {routers.map(renderMenuItem)}
      </Menu>
    </Layout.Sider>
  );
}

export default Sidebar;
